import { HTTPServiceClient } from '@/packages/http/service';
import * as endpoint from './endpoints';
import {
  ValidateUserDetailsRequest,
  ValidatedUserDetails,
  AcknowledgeSubmissionRequest
} from './types';
/**
 * --------------------------------------------------
 *	Organisation HTTP Service
 * --------------------------------------------------
 **/
export const AppService = {
  async validateUserDetails(
    validateUserDetailsRequest: ValidateUserDetailsRequest
  ): Promise<ValidatedUserDetails> {
    const { data } = await HTTPServiceClient.get(
      endpoint.VALIDATE_USER_DETAILS(
        validateUserDetailsRequest.orgId,
        validateUserDetailsRequest.email
      )
    );
    return data;
  },

  async acknowledgeSubmissionRequest(
    acknowledgeSubmissionRequest: AcknowledgeSubmissionRequest
  ): Promise<Response> {
    const { data } = await HTTPServiceClient.put(
      endpoint.ACKNOWLEDGE_SUBMISSION_REQUEST,
      acknowledgeSubmissionRequest
    );
    return data;
  }
};
